<template>
    <v-dialog v-model="show" max-width="500">
        <v-card v-if="purchase" class="v-card--dialog v-card--dialog--sm">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">상품리뷰</h3>
                <v-btn fab color="transparent" @click="close" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>

            <div class="v-card--dialog__body">
                <section class="page-section page-section--sm pt-0">
                    <v-row align="center" class="row--small">
                        <v-col cols="3">
                            <div class="border">
                                <v-img :src="purchase?.product?.thumb" max-width="100" :aspect-ratio="1/1" contain></v-img>
                            </div>
                        </v-col>
                        <v-col>
                            <div class="mx-2 text-truncate"><b v-html="purchase.product.name"></b></div>
                            <div v-if="purchase.product.type == 'option'" class="mx-2 text-truncate">[{{ purchase.product.optionalNames.toString() }}] : {{ purchase.product.optionalValues.toString() }}</div>
                        </v-col>
                    </v-row>
                </section>

                <section class="page-section page-section--sm">
                    <div class="mb-10px mb-md-20px">
                        <h3 class="tit tit--xs">별점</h3>
                        <v-divider class="grey lighten-1 mt-10px"></v-divider>
                    </div>
                    <v-rating v-model="review.rating" label="별점" color="yellow darken-1" background-color="grey" dense length="5" />
                </section>

                <section class="page-section page-section--sm pb-0">
                    <v-textarea v-model="review.content" placeholder="후기를 작성해주세요" persistent-placeholder outlined hide-details />
                </section>
            </div>

            <div class="v-card--dialog__foot">
                <v-row class="row--x-small">
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="save" color="primary">저장</v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return {
            show: false,

            purchase: null,
            review: null
        }
    },
    methods: {
        open(){
            this.show = true;
            this.review = {
                _purchase: this.purchase._id,
                _product: this.purchase.product._mainProduct || this.purchase.product._id,

                rating: 5,
                content: null
            }
        },
        close(){
            this.show = false;
        },
        validate(){
            try{
                if(!this.review.content) alert("후기 내용을 작성해주세요");
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async save(){
            if(this.validate() && await this.$confirm("후기를 등록하시겠습니까?")){
                await api.v1.me.shop.reviews.post(this.review);
                alert("등록되었습니다");
                this.close();
            }
        }
    },
    watch: {
        show(){
            if(!this.show) this.$emit("close");
        },
    }
}
</script>